import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Dygraphs from '@qogni/dygraphs';

var parseFloat = function parseFloat(val) {
  return val === null ? NaN : val;
}; // https://github.com/danvk/dygraphs/pull/896


var OptimizedDataHandler = /*#__PURE__*/function (_Dygraphs$DataHandler) {
  _inherits(OptimizedDataHandler, _Dygraphs$DataHandler);

  var _super = _createSuper(OptimizedDataHandler);

  function OptimizedDataHandler() {
    var _this;

    _classCallCheck(this, OptimizedDataHandler);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.seriesToPoints = function (series, setName, boundaryIdStart) {
      var points = [];

      for (var i = 0; i < series.length; ++i) {
        points.push({
          x: NaN,
          y: NaN,
          xval: parseFloat(series[i][0]),
          yval: series[i][1] === null ? null : parseFloat(series[i][1]),
          name: setName,
          idx: i + boundaryIdStart,
          canvasx: NaN,
          canvasy: NaN
        });
      }

      _this.onPointsCreated_(series, points);

      return points;
    }, _temp));
  }

  return OptimizedDataHandler;
}(Dygraphs.DataHandlers.DefaultHandler);

export { OptimizedDataHandler as default };